<template>
  <div class="navigation">
    <div class="d-flex justify-content-center">
      <b-row class="navigation__elems">

        <div class="navigation__language" style="width: 100px">
          <p class="font__futura-book"
             @click="changeLanguage('EN')"
             :class="{'navigation__language-active': language === 'EN',
                      'navigation__language-inactive': language === 'HU'}">EN</p>
          <p class="line">|</p>
          <p class="font__futura-book"
             @click="changeLanguage('HU')"
             :class="{'navigation__language-active': language === 'HU',
                      'navigation__language-inactive': language === 'EN'}">HU</p>

        </div>
        <b-col cols="9">
          <transition name="fade" mode="out-in">
            <div v-if="language === 'HU'" key="menu-hu">
              <p class="font__futura-medium" @click="scroll('block-about')" :class="{p_active: active === 'block-about'}">RÓLUNK</p>
              <p class="font__futura-medium" @click="scroll('block-soundlab')" :class="{p_active: active === 'block-soundlab'}">SOUNDLAB</p>
              <p class="font__futura-medium" @click="scroll('block-video')" :class="{p_active: active === 'block-video'}">MÉDIA</p>
              <p class="font__futura-medium" @click="scroll('block-contact')" :class="{p_active: active === 'block-contact'}">KAPCSOLAT</p>
              <p class="font__futura-medium" @click="redirectToShop" :class="{p_active: active === 'block-contact'}">SHOP</p>
            </div>

            <div v-if="language === 'EN'" key="menu-en">
              <p class="font__futura-medium" @click="scroll('block-about')" :class="{p_active: active === 'block-about'}">ABOUT</p>
              <p class="font__futura-medium" @click="scroll('block-soundlab')" :class="{p_active: active === 'block-soundlab'}">SOUNDLAB</p>
              <p class="font__futura-medium" @click="scroll('block-video')" :class="{p_active: active === 'block-video'}">MEDIA</p>
              <p class="font__futura-medium" @click="scroll('block-contact')" :class="{p_active: active === 'block-contact'}">CONTACT</p>
              <p class="font__futura-medium" @click="redirectToShop" :class="{p_active: active === 'block-contact'}">SHOP</p>
            </div>
          </transition>

        </b-col>
        <b-col>
          <img src="../assets/img/logo.png" alt="logo" @click="setPercentage(0)">
        </b-col>


      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  computed: {
    language: function () {
      return this.$store.getters.language;
    }
  },
  data: function () {
    return {
      active: 'block-about',
    }
  },
  methods: {
      redirectToShop(){
          window.open('https://shop.asanbudapest.com/ruhazat', '_blank');
      },
    changeLanguage(language) {
      this.$store.commit('setLanguage', language);
      this.$store.commit('setScrollPercentage', 0);
    },
    setPercentage(percentage) {
      this.$store.commit('setScrollPercentage', percentage);
      this.$store.commit('setOpeningVideo', true);
    },
    scroll(id) {
      this.active = id;
      const element = document.getElementById(id);
      const offset = 170;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  },
}
</script>

<style scoped>

img {
  width: 190px;
  cursor: pointer;
}

.col-9 p {
  color: white;
  cursor: pointer;
  font-size: 12pt;
  letter-spacing: 3pt;
  margin-right: 45px;
  line-height: 35px;

  text-transform: uppercase;
  text-decoration: none;
  display: inline-block;
  position: relative;
}

.col-9 p:after {
  background: none repeat scroll 0 0 transparent;
  bottom: -1px;
  content: "";
  display: block;
  height: 1px;
  left: 50%;
  position: absolute;
  background: #fff;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0;
}

.p_active{
  /*background: none repeat scroll 0 0 transparent;*/
  /*bottom: 0px;*/
  /*content: "";*/
  /*display: block;*/
  /*height: 1px;*/
  /*left: 50%;*/
  /*position: absolute;*/
  /*background: #fff;*/
  /*transition: width 0.3s ease 0s, left 0.3s ease 0s;*/
  /*width: 0;*/
  /*padding-bottom: 4px;*/
  border-bottom: 1px solid white;
}

.col-9 p:hover:after {
  width: 100%;
  left: 0;
}

.navigation__language {
  position: absolute;
  left: 770px;
  bottom: 0;
}

.navigation__language .line{
  pointer-events: none;
  color: #aebfbd;

}

.navigation__language-active {
  color: white;
}

.navigation__language-inactive {
  color: #aebfbd;
}

.navigation__language-inactive:hover {
  color: white;
}

.navigation__language p {
  display: inline;
  font-size: 10pt;
  letter-spacing: 2pt;
  margin-right: 5px;
  cursor: pointer;
}


.navigation__elems {
  width: 1200px;
  margin-top: 30px;
  height: 110px;
  position: relative;
  /*background-color: black;*/
  border-left: 2px solid var(--asan-green-light);
  border-right: 2px solid var(--asan-green-light);
}

.navigation {
  top: 0;
  left: 0;
  height: 170px;
  width: 100%;
  position: fixed;
  background-color: var(--asan-green);
  z-index: 2;
}

.col-9 {
  margin-right: -30px;
  display: flex;
  padding-top: 37px;
  padding-left: 70px;
}

.col {
  border-left: 2px solid var(--asan-green-light);
  padding-left: 95px;
  padding-top: 80px;
}

@media screen and (max-width: 1024px) {
  .welcome{
    display: none;
  }
}

</style>